import { captureMonitoringException } from "./sentry";

export type PlatformFeedbackType =
  | "BUG_REPORT"
  | "FEATURE_REQUEST"
  | "GENERAL_COMMENT";

export interface PlatformFeedbackData {
  npsScore?: number | null;
  feedbackType?: PlatformFeedbackType;
  comment: string;
}

export interface ReviewData {
  appointmentId: string;
  patientId?: string;
  overallScore: number;
  bedsideMannerScore?: number;
  punctualityScore?: number;
  comment?: string;
  platformFeedback?: {
    npsScore: number | null;
    feedbackType: PlatformFeedbackType;
    comment: string;
  };
}

export class ReviewService {
  private apiUrl: string;
  private token: string;

  constructor(apiUrl: string, token: string) {
    this.apiUrl = apiUrl;
    this.token = token;
  }

  async submitReview(reviewData: ReviewData): Promise<void> {
    const url = `${this.apiUrl}/reviews?token=${encodeURIComponent(this.token)}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reviewData),
    });

    if (!response.ok) {
      let errorMessage = `Error ${response.status}: ${response.statusText}`;
      try {
        const errorData = await response.json();
        if (errorData.message) {
          errorMessage = errorData.message;
        } else if (errorData.error) {
          errorMessage = typeof errorData.error === "string"
            ? errorData.error
            : errorData.error.message || errorMessage;
        }
      } catch {
        // Ignore JSON parsing errors
      }
      captureMonitoringException(new Error(errorMessage), {
        feature: "review-submit",
        appointmentId: reviewData.appointmentId,
        status: response.status,
      });
      throw new Error(errorMessage);
    }
  }
}
